module.exports = __webpack_public_path__ + "static/media/Icon awesome-keyboard.ebdfde12.svg";